export const environment = {
  "production": false,
  "appName": "@ec/fleet-dashboard-v2",
  "appVersion": "1.0.22",
  "apiUrl": "https://public.dev3.dev3.elevationcurb.com/api/v1",
  "webAppUrl": "https://webapp.dev3.dev3.elevationcurb.com",
  "hubAppUrl": "https://hub.dev3.dev3.elevationcurb.com",
  "installationApiUrl": "https://install.dev3.dev3.elevationcurb.com/api",
  "liveDataServiceUrl": "wss://lds.dev3.dev3.elevationcurb.com",
  "timezoneApiKey": "AIzaSyD3NiA0YUwPfnOPGP5fyWkWdNtO5LIlQlU",
  "auth0": {
    "domain": "dev3-curbenergy.us.auth0.com",
    "clientId": "zFmB8pjABIkJtbYyYuEF0faPNFJEhy5F",
    "redirectUri": window.location.origin,
    "audience": "public.energycurb.com",
    "responseType": "token id_token",
    "scope": "openid profile email",
    "connection": "users"
  }
};
